import AppPage from '@/components/app-page/index.vue';

export default [{
  path: '/log-analysis',
  component: AppPage,
  name: 'LogAnalysis',
  meta: {
    title: '日志分析',
    style: 'notebook-2',
  },
  children: [
    // {
    //   path: 'trace',
    //   name: 'Trace',
    //   component: () => import('@/views/Trace.vue'),
    //   meta: {
    //     title: '链路追踪',
    //   },
    // },
    {
      path: 'search',
      name: 'Search',
      component: () => import('@/views/log-analysis/search/index.vue'),
      meta: {
        title: '日志查询',
        style: 'search',
        // bizChannel
      },
    },
    {
      path: 'link',
      name: 'LogAnalysisTrackingLink',
      component: () => import('@/views/log-analysis/link/index.vue'),
      meta: {
        title: '链路追踪',
        activeMenu: '/tracking/link',
        style: 'magic-stick',
      },
      props: true,
    },
  ],
}];
